import React from 'react'
import Lottie from 'react-lottie'
import Styled from 'styled-components'

import * as animationData from './loader_seeyousoon.json'

const AnimationContainer = Styled.div`
  margin: ${props =>
    props.margin ? props.margin : props.isMobile ? '1rem' : '1.7rem'};
  display: ${props => (props.isMini ? 'inline-flex' : 'flex')};
  justify-content: center;
  align-items: center;
  ${props => (props.isMobile ? 'height: 200px;' : null)}
`

const LoaderAnimation = ({ isMobile, isMini, isMedium, margin }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  let height = isMobile ? '150px' : '100%'
  let width = isMobile ? '150px' : '100%'
  if (isMini) {
    height = '30px'
    width = '30px'
  }
  if (isMedium) {
    height = '125px'
    width = '125px'
  }
  return (
    <AnimationContainer isMobile={isMobile} isMini={isMini} margin={margin}>
      <Lottie
        width={width}
        height={height}
        isClickToPauseDisabled
        options={defaultOptions}
        isStopped={false}
      />
    </AnimationContainer>
  )
}

export default LoaderAnimation
